module.exports = __webpack_public_path__ + "media/ok.b94d978e.mp3";